import React from "react";
import PropTypes from 'prop-types';

function Modal(props) {
    return (
        <div className="modal fade" id="application-modal" tabIndex="-1" role="dialog" aria-labelledby="applicationModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modal-label">{props.title}</h5>
                    </div>
                    <div id="modal-body">
                        {props.body}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

Modal.propTypes = {
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
};

export default Modal;